import classNames from "classnames";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

import { IconExpand01, IconMinimize01 } from "@pentabd/icons";
import { Button, Text } from "@pentabd/ui";

// import { PROMOTION_STATUS } from "@constants/status.hrm";
import { PromotionDetailsType } from "@type/HRM/promotions";

// const { REFUSE, RECOMMEND } = PROMOTION_STATUS;

interface AccordionDataType {
  accordionHeader?: {
    title?: string;
    subtitle?: string;
  };
  accordionBody?: ReactNode;
  className?: string;
  action: (
    promotionDetailsId: number,
    actionType: string,
    update?: boolean,
  ) => void;
  showActionBtn: boolean;
  promotionDetailsData: PromotionDetailsType;
}

export const AccordionLayout = ({
  accordionHeader,
  accordionBody,
  className,
  // action,
  // showActionBtn,
  // promotionDetailsData,
}: AccordionDataType) => {
  const [opened, setOpened] = useState(false);

  const { t } = useTranslation();

  // const isRecommended = promotionDetailsData.recommendation.isRecommended;

  // const ActionButton = ({
  //   update,
  //   fillType,
  //   label,
  // }: {
  //   update: boolean;
  //   fillType: "fill" | "outline";
  //   label: string;
  // }) => (
  //   <Button
  //     size="sm"
  //     fill={fillType}
  //     type="primary"
  //     onClick={() =>
  //       action(
  //         promotionDetailsData.promotionDetailsId,
  //         label === "REFUSE" ? REFUSE : RECOMMEND,
  //         update,
  //       )
  //     }
  //   >
  //     {t(`INITIATE_PROMOTION.FORM.ACCORDION_BUTTON.${label}`)}
  //   </Button>
  // );

  return (
    <div
      className={classNames("accordion-item pointer", className, {
        "accordion-item--opened": opened,
      })}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center gap-8">
            {accordionHeader?.title && (
              <Text size="lg" weight="semibold" color="dark">
                {accordionHeader?.title}
              </Text>
            )}

            {/* {isRecommended !== null ? (
              <Badge
                label={
                  isRecommended
                    ? t(
                      "INITIATE_PROMOTION.FORM.RECOMMENDATION_STATUS.RECOMMENDED",
                    )
                    : t("INITIATE_PROMOTION.FORM.RECOMMENDATION_STATUS.REFUSED")
                }
                type={isRecommended ? "success" : "danger"}
                size="sm"
              />
            ) : null} */}
          </div>
          {accordionHeader?.subtitle && (
            <Text size="sm" color="subtitle1">
              {accordionHeader?.subtitle}
            </Text>
          )}
        </div>
        <div className="d-flex align-items-center gap-6">
          {/* {showActionBtn && (
            <>
              {isRecommended === null && (
                <>
                  <ActionButton
                    update={false}
                    fillType="outline"
                    label="REFUSE"
                  />
                  <ActionButton
                    update={false}
                    fillType="fill"
                    label="RECOMMEND"
                  />
                </>
              )}
              {isRecommended === true && (
                <ActionButton update={true} fillType="outline" label="REFUSE" />
              )}
              {isRecommended === false && (
                <ActionButton update={true} fillType="fill" label="RECOMMEND" />
              )}
            </>
          )} */}

          <Button
            size="sm"
            fill="outline"
            type="light"
            onClick={() => setOpened(!opened)}
          >
            {opened ? (
              <IconMinimize01 size={20} fill="subtitle2" />
            ) : (
              <IconExpand01 size={20} fill="subtitle2" />
            )}
            {t(
              `INITIATE_PROMOTION.FORM.ACCORDION_BUTTON.${opened ? "MINIMIZE" : "EXPAND"
              }`,
            )}
          </Button>
        </div>
      </div>
      <div className="accordion-item__inner">
        <div className="accordion-item__content">{accordionBody}</div>
      </div>
    </div>
  );
};
